import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import {SECTION_CONSTANTS} from "../../../../constants/global-constant";
import { formatFlexibleDate } from '../../../../utils/safe-date.util';

@Component({
    selector: 'app-taxpayer-basic-info-en-v2',
    templateUrl: './taxpayer-basic-info-en-v2.component.html',
    styleUrls: ['./taxpayer-basic-info-en-v2.component.css'],
    standalone: false
})
export class TaxpayerBasicInfoEnV2Component implements OnInit, OnChanges {

  constructor() { }
   @Input() returnData
   @Input() printActive: boolean;


  userInfo: any
  submissionDate:string
  lastEmployer: string
  section: any;
  dobDayChars: string[] = [];
  dobMonthChars: string[] = [];
  dobYearChars: string[] = [];

  ngOnInit(): void {
  }

  splitDobParts(dob: any): string[][] {
    const empty = [[], [], []];
    if (dob == null || String(dob).trim() === '') {
      return empty;
    }
    const parts = String(dob).split('/');
    if (parts.length < 3) {
      return empty;
    }
    return [
      String(parts[0] || '').split(''),
      String(parts[1] || '').split(''),
      String(parts[2] || '').split('')
    ];
  }

  setDobChars(dob: any): void {
    const parts = this.splitDobParts(dob);
    this.dobMonthChars = parts[1];
    this.dobDayChars = parts[0];
    this.dobYearChars = parts[2];
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.userInfo = this?.returnData?.profileData;
    // this.submissionDate = this.returnData?.submissionInfo?.submissionDate ? new Date(this.returnData?.submissionInfo?.submissionDate).toLocaleDateString('bn-BD') : new Date().toLocaleDateString('bn-BD')
    this.submissionDate = this.returnData?.submissionInfo?.submissionDate ? this.formatDate(this.returnData?.submissionInfo?.submissionDate) : this.formatDate(new Date().toISOString())
    this.lastEmployer = this.returnData?.headSummery?.salarySummery?.LAST_EMPLOYMENT_OFFICE
    this.setDobChars(this.userInfo ? this.userInfo.dob : null);

    let sectionValue = this.returnData?.submissionInfo?.section ? this.returnData?.submissionInfo?.section : SECTION_CONSTANTS.REGULAR.value;
    this.section = Object.values(SECTION_CONSTANTS)
      .find(item => item.value === sectionValue);
  }

  private formatDate(dateValue: string | Date): string {
    return formatFlexibleDate(dateValue, '/');
  }
}
